<template>
  <v-container class="share-magic-link-email">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <ContactsInput
          v-model="to"
          :label="$tf('Recipients')"
          :initial-selected="to"
          :rules="toRules"
          prepend-icon="email"
          required
        />
        <v-text-field
          class="share-magic-link-email__body"
          :label="$tf('Body')"
          v-model="body"
          multi-line
          prepend-icon="edit"
        />
      </v-form>
  </v-container>
</template>

<script>
import Api from '~/store/idonia-api/api.js'
import ContactsInput from '~/components/account/ContactsInput.vue'

export default {
  name: 'ShareMagicLinkEmail',
  components: {
    ContactsInput
  },
  props: {
    publicUrlId: {
      type: Number,
      default: 0
    },
    file: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      valid: false,
      to: [],
      body: '',
      toRules: [v => v.length > 0 || this.$t('Field required', { field: this.$tf('Recipients') })]
    }
  },
  methods: {
    async accept () {
      this.$refs.form.validate()

      if (this.valid) {
        const actors = []
        const guests = []

        this.to.forEach(item => {
          item.type === 'guest'
            ? guests.push(item.name)
            : actors.push(item.id)
        })

        try {
          await Api.postV2('public-url/share/' + this.publicUrlId, {
            data: {
              'host_url': window.location.origin,
              guests,
              actors,
              message: this.body
            }
          })
        } catch (error) {
          console.error(error)

          await this.$store.dispatch('feedback/addSnack', {
            text: error,
            type: 'error',
            timeout: 2000
          })
        }

        await this.$store.dispatch('feedback/addSnack', {
          text: this.$tf('Thank you, your message has been sent'),
          type: 'info',
          timeout: 2000
        })

        return
      }

      throw new Error('Validation error')
    }
  }
}
</script>

<style scoped lang="scss">
  .share-magic-link-email {
    &__body {
      /deep/ {
        .input-group__prepend-icon {
          align-self: start;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogShareMagicLinkEmail.vue